// extracted by mini-css-extract-plugin
export default {"coverLink":"bP-z","contentBox":"cP-z","zapposPromoContainer":"dP-z","zapposPromoGroupContainer":"eP-z","promos":"fP-z","bottom":"gP-z","top":"hP-z","right":"iP-z","left":"jP-z"};